import React, { useState, useEffect, createContext, useContext } from 'react'
import { injectIntl } from 'gatsby-plugin-intl'
import { StringParam, useQueryParam } from 'use-query-params'
import { Box, useColorMode } from 'theme-ui'
import WaitlistModal from '../WaitlistModal'
import CollectionFilterBar from '~/components/Collection/FilterBar'
import CollectionList from '~/components/Collection/List'
import Heading from '~/components/IntlComponents/Heading'
import { GenericSectionDivider } from '~/components/Generic/SectionDivider'

const WaitListContext = createContext({})
export const useWaitList = () => useContext(WaitListContext)

const ProductListPage = ({
  catalog,
  colorList,
  currentCollectionSlug,
  setCurrentCollectionSlug,
}) => {
  const [currentCollectionParam, setCurrentCollectionParam] = useQueryParam(
    'collection',
    StringParam,
  )

  const [collectionsToShow, setCollectionsToShow] = useState(
    catalog.collections.filter(c => !c.slug.includes('dietary')),
  )

  const [_, setColorMode] = useColorMode('hey-hey-elote')

  const [dataWaitlist, setDataWaitlist] = useState({
    open: false,
    currentVariant: null,
    product: null,
  })

  const onCloseModal = () =>
    setDataWaitlist(prev => ({
      ...prev,
      open: false,
    }))

  const handleDataWaitlist = (currentVariant, product) =>
    setDataWaitlist({
      open: true,
      currentVariant,
      product,
    })

  // if the collection in the URL changes via external means (e.g. a footer link was clicked), update the component
  useEffect(() => {
    setCurrentCollectionSlug(currentCollectionParam || null)
  }, [currentCollectionParam])

  const onFilter = slug => {
    // setCurrentCollectionParam updates the URL but does not update currentCollectionParam
    setCurrentCollectionParam(slug || undefined, 'replaceIn')
    setCurrentCollectionSlug(slug)
    if (typeof window !== 'undefined') {
      window.pintrk('track', 'viewcategory', {
        event_id: 'eventId0005',
        line_items: [
          {
            product_category: slug || 'Shop-all',
          },
        ],
      })
    }
  }

  const currentCollection = currentCollectionSlug
    ? catalog.collections.find(({ slug }) => slug === currentCollectionSlug)
    : null

  useEffect(() => {
    const newCollection = currentCollection
      ? [currentCollection]
      : // hide dietary & new-launch collection on shop all
        // only shows up via a direct link
        catalog?.collections.filter(
          c => !c.slug.includes('dietary'),
          // &&
          // !c.slug.includes('new-launch')
        )

    setCollectionsToShow(newCollection)
  }, [currentCollection])

  useEffect(() => {
    setColorMode(colorList[`${currentCollectionSlug}`] ?? 'hey-hey-elote')
  }, [currentCollectionSlug, setColorMode])

  return (
    <Box
      sx={{
        background: 'var(--theme-ui-colors-secondary)',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ background: 'var(--theme-ui-colors-primary)' }}>
        <Heading
          variant="text.h1"
          sx={{
            color: 'var(--theme-ui-colors-secondary)',
            padding: '1em 0',
            textTransform: 'uppercase',
            textAlign: 'center',
          }}
        >
          {currentCollection ? `${currentCollection.pcpHeader}` : `Shop all`}
        </Heading>
      </Box>
      <GenericSectionDivider
        sx={{
          fill: 'primary',
          stroke: 'primary',
        }}
      />

      <CollectionFilterBar
        collections={catalog.collections}
        currentCollection={currentCollection}
        onChange={onFilter}
      />

      <WaitlistModal {...dataWaitlist} onCloseModal={onCloseModal} />

      <WaitListContext.Provider value={{ handleDataWaitlist }}>
        {collectionsToShow.map(collection => (
          <CollectionList
            key={collection.slug}
            collection={collection}
            currentCollection={currentCollection}
          />
        ))}
      </WaitListContext.Provider>
    </Box>
  )
}

export default injectIntl(ProductListPage)
